import * as React from 'react';
import { useId } from 'react';

import useTheme from 'hooks/useTheme';

import { HiddenLabel, Option, SwitchGroup } from './ThemeSwitch.styled';

const OPTIONS = [
    {
        value: 'light',
        label: 'Light theme',
        path: 'M12 3v1m0 16v1M3 12h1m16 0h1M5.6 5.6l.7.7m11.4 11.4.7.7M5.6 18.4l.7-.7M17.7 6.3l.7-.7M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
    },
    {
        value: 'dark',
        label: 'Dark theme',
        path: 'M20.5 13A8.5 8.5 0 0 1 11 3.5 8.5 8.5 0 1 0 20.5 13Z',
    },
    {
        value: 'system',
        label: 'System theme',
        path: 'M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm4 17h8m-4-4v4',
    },
] as const;

const ThemeSwitch = () => {
    const { preference, setPreference } = useTheme();
    const name = useId();

    return (
        <SwitchGroup>
            <HiddenLabel as="legend">Appearance</HiddenLabel>
            {OPTIONS.map(({ value, label, path }) => (
                <Option key={value} title={label}>
                    <input
                        type="radio"
                        name={name}
                        value={value}
                        aria-label={label}
                        checked={preference === value}
                        onChange={() => setPreference(value)}
                    />
                    <span>
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <path d={path} />
                        </svg>
                    </span>
                </Option>
            ))}
        </SwitchGroup>
    );
};

export default ThemeSwitch;
